<template>
  <div :id="componentId" class="sp-txt-component" :style="sectionStyle">
    <div class="sp-txt-content">
      <span class="sp-txt-text" :style="textStyle" v-html="formattedText"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpText',
  props: {
    componentId: {
      type: String,
      default: 'sp_txt'
    }
  },
  data() {
    return {
      text: '请输入文字内容',
      fontSize: 16,
      fontColor: '#333333',
      bgImageUrl: '',
      bgColor: '#ffffff'
    };
  },
  computed: {
    sectionStyle() {
      const style = {
        backgroundColor: this.bgColor
      };
      if (this.bgImageUrl) {
        style.backgroundImage = `url(${this.bgImageUrl})`;
        style.backgroundRepeat = 'no-repeat';
        style.backgroundPosition = 'center';
        style.backgroundSize = 'cover';
      }
      return style;
    },
    textStyle() {
      return {
        fontSize: this.fontSize + 'px',
        color: this.fontColor
      };
    },
    formattedText() {
      return (this.text || '').replace(/\n/g, '<br>');
    }
  }
};
</script>

<style scoped>
.sp-txt-component {
  position: relative;
  width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  min-height: 100px;
  padding: 40px 0;
  cursor: pointer;
}

.sp-txt-content {
  position: relative;
  width: 1400px;
  margin: 0 auto;
}

.sp-txt-text {
  display: block;
  line-height: 1.8;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>
